export default "__VITE_ASSET__BSfCwuc5__"